export class AnalystDashboardDetailModel {
    constructor() {
        this.activeEntriesCount = 0;
        this.ownEntriesAddedCount = 0;
        this.recentlyAddedEntriesCount = 0;
        this.recentlyUpdatedEntriesCount = 0;
        this.ownFavouriteEntriesCount = 0;
        this.mapStates = [];
    }
}
export default class AnalystDashboardDetail extends AnalystDashboardDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
